// Sends a message into the Kit chat on the user's behalf by filling the chat
// input and submitting its form. Shared by the interactive Kit block
// controllers (kit-choices, kit-question-form) and mirrors the approach used by
// chat_action_controller. Returns true if the message was submitted.
export function submitKitMessage(chatId, message) {
  const form = document.getElementById(`new_message_${chatId}`);
  if (!form) return false;

  const input =
    form.querySelector("textarea[name='message[content]']") ||
    form.querySelector("input[name='message[content]']");
  if (!input) return false;

  input.value = message;
  form.requestSubmit();
  return true;
}
